export default "__VITE_ASSET__n62onQXn__"